import React, { useState } from 'react';
import { BsExclamationTriangleFill } from 'react-icons/bs';

const SHOW_AT_MOST = 8;

/**
 * Red banner across the top of the masking inventory listing CONFIRMED uniqueness
 * conflicts (a Profile-recorded PK/UNIQUE column masked with an algorithm that does not
 * guarantee unique output). Renders nothing when there are none. Same data as the per-row
 * icons (`collectInventoryIssues`), so the two never disagree.
 */
export default function InventoryIssuesBanner({ issues }) {
  const [expanded, setExpanded] = useState(false);
  const list = Array.isArray(issues) ? issues : [];
  if (list.length === 0) return null;
  const n = list.length;
  const shown = expanded ? list : list.slice(0, SHOW_AT_MOST);
  return (
    <div className='alert alert-danger mb-2' role='alert' data-testid='inventory-issues-banner'>
      <div className='d-flex align-items-center mb-1'>
        <BsExclamationTriangleFill className='mr-2 flex-shrink-0' />
        <strong data-testid='inventory-issues-count'>
          {n === 1
            ? '1 column will fail masking with a duplicate-key error'
            : `${n} columns will fail masking with duplicate-key errors`}
        </strong>
      </div>
      <ul className='mb-0 pl-4' style={{ fontSize: 13 }}>
        {shown.map((i) => (
          <li key={`${i.tableKey}.${i.field}`} data-testid={`inventory-issue-${i.tableKey}-${i.field}`}>
            <code>
              {i.schema ? `${i.schema}.` : ''}
              {i.table}.{i.field}
            </code>
            {' — '}
            <strong>{i.algorithm}</strong>: {i.message}
          </li>
        ))}
      </ul>
      {n > SHOW_AT_MOST && (
        <button
          type='button'
          className='btn btn-link p-0 mt-1'
          style={{ fontSize: 13 }}
          onClick={() => setExpanded((v) => !v)}
          data-testid='inventory-issues-show-all'
        >
          {expanded ? 'Show fewer' : `Show all ${n}`}
        </button>
      )}
    </div>
  );
}
